import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const KycPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const orderId = searchParams.get("orderId") || searchParams.get("order_id");
    const memberId = searchParams.get("memberId") || searchParams.get("member_id");

    if (orderId && memberId && orderId !== "undefined" && memberId !== "undefined") {
      navigate(`/?orderId=${orderId}&memberId=${memberId}&openKyc=true`, { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default KycPage;
